/**
 * Frontend Application Configuration
 *
 * All branding and domain values come from environment variables so the entire
 * app can be rebranded by changing .env.production only.
 *
 * Usage:
 *   import config from '../config/appConfig';
 *   <h1>{config.appName}</h1>
 */

const config = {
  // ─── Identity ────────────────────────────────────────────────────────────
  appName:      process.env.REACT_APP_NAME       || 'Emergency Health Records',
  appShortName: process.env.REACT_APP_SHORT_NAME || 'EHR-ID',
  appTagline:   process.env.REACT_APP_TAGLINE    || 'Instant access to critical medical information',
  appIcon:      process.env.REACT_APP_ICON       || '🏥',

  // ─── Domain / API ────────────────────────────────────────────────────────
  apiUrl:       process.env.REACT_APP_API_URL    || 'http://localhost:5000',
  domain:       process.env.REACT_APP_DOMAIN     || 'ehrid.com',

  // ─── Asset prefix ────────────────────────────────────────────────────────
  assetPrefix:  process.env.REACT_APP_ASSET_PREFIX || 'MED',
};

export default config;
